import { createEffect, createEvent, restore, sample } from 'effector'
import { getAnalytics, type Analytics } from 'firebase/analytics'
import { type FirebaseApp } from 'firebase/app'

export const init = createEvent<FirebaseApp>()
export const done = createEvent<void>()

// get analytics
const getAnalyticsFx = createEffect<FirebaseApp, Analytics>(getAnalytics)
export const $analytics = restore<Analytics>(getAnalyticsFx.doneData, null)

// init firebase analytics
sample({
  clock: init,
  target: getAnalyticsFx,
})

// trigger done
sample({
  clock: getAnalyticsFx.finally,
  target: done,
})
